import { Component } from '@angular/core';

@Component({
  selector: 'new-version',
  imports: [],
  templateUrl: './new-version.component.html',
})
export class NewVersionComponent {
  onReload!: () => void;

  reload(): void {
    if (this.onReload) this.onReload();
  }
}
